<template>
	<div class="flex items-center">
		<h3 class="typo-h4 mr-2">
			Sdílet článek
		</h3>
		<a
			:href="`https://www.facebook.com/sharer.php?u=${route.href}`"
			target="_blank"
			class="typo-body-xl text-[#1877F2] mx-2"
			rel="noopener noreferrer"
			title="Sdílet na Facebooku"
			aria-label="Sdílet na Facebooku"
		>
			<NuxtIcon filled name="custom/facebook" />
		</a>
		<a
			:href="`https://twitter.com/intent/tweet?url=${route.href}`"
			target="_blank"
			class="typo-body-xl text-[#1D9BF0] mx-2"
			rel="noopener noreferrer"
			title="Sdílet na síti X"
			aria-label="Sdílet na síti X"
		>
			<NuxtIcon filled name="custom/x" />
		</a>
		<a
			:href="`mailto:?body=${route.href}&subject=${title}`"
			target="_blank"
			class="typo-body-xl text-icon-primary mx-2"
			rel="noopener noreferrer"
			title="Sdílet e-mailem"
			aria-label="Sdílet e-mailem"
		>
			<NuxtIcon filled name="mail" />
		</a>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		title: string
	}

	defineProps<Props>();

	const route = useBrowserLocation();
</script>
